import React from "react";
import "./SkillsHapUniversityHero.css";
import uni from "../Images/uni.png"; // replace with actual path
import { Link } from 'react-router-dom';

const SkillsHapUniversityHero = () => {
  return (
    <main className="skill-main-1">
       <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    <section className="skills-wrapper-2">
      <div className="skills-content-3">
        <div className="skills-text-content-4">
          <p className="skills-subtitle-5">UNIVERSITY CAREER SERVICES</p>
          <h1>
            <span className="highlight-6">AI-Powered</span> Career Solutions  for<br />
            Colleges & Universities
          </h1>
          <p className="skills-description-7">
            Automate workflows, track student outcomes, and support career development with advanced AI tools built for institutions.
          </p>
          <div class="cta-button-wrapper11">
          <Link to="/BookDemoForm"><button className="cta-button-8">Schedule a Demo</button></Link>
          </div>
        </div>
        <div className="skills-image-content-9">
          <div className="skills-image-wrapper-10">
            <img src={uni} alt="University Module-11" className="skills-main-image-12" />
            <div className="skills-overlay-card-13">
              <ul>
                <li><span className="status-icon-green-14"></span> AI-generated Resume Insights</li>
                <li><span className="status-icon-yellow-15"></span> Track Student Applications</li>
                <li><span className="status-icon-red-16"></span> Career Readiness Reports</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

        <section className="skills-success-section-17">
  <div className="success-container-18">
    <h2 className="success-heading-19">
      Empower Students to <span>Thrive in Their Careers</span> with SkillsHap
    </h2>
    <p className="success-description-20">
      Streamline career development, enhance job readiness, and connect students to real opportunities through our intelligent, university-focused career platform.
    </p>
  </div>
</section>

   {/* Call to Action */}
      <section className="univ-cta-section-21">
        <h2>Partner with SkillsHap University</h2>
        <p>Let’s collaborate to bring industry closer to your students and unlock career success for all.</p>
        <div className="cta-buttons-22">
         <Link to="/BookDemoForm"> <button className="btn-join-23">Schedule University Demo</button></Link>
         <Link to= "/SignupForm"><button className="btn-partner-24">Join the SkillsHap Network</button></Link>
        </div>
      </section>

    </main>

  );
};

export default SkillsHapUniversityHero;
